<template>
    <div class="page-login">
        <div class="login-logo">
            <!-- <i class="iconfont icon-xinxiwanglogo"></i> -->
            <img src="@/assets/pics/dwwblog.png" alt="" />
        </div>
        <div class="login-page-inner">
            <div v-if="showPassWord" class="passwordLogin">
                <div class="iconBox" @click="toggleLogin('qrcode')">
                    <el-tooltip placement="top" content="二维码登陆">
                        <!-- <i class="iconfont icon-erweima1"></i> -->
                        <img src="@/assets/pics/xzjh.png" alt="" />
                    </el-tooltip>
                </div>
                <p class="title">地网无边平台</p>
                <el-form ref="loginForm" :model="formData" :rules="formRules" label-width="0px">
                    <el-form-item prop="username">
                        <el-input
                            ref="username"
                            v-model="formData.username"
                            name="username"
                            placeholder="请输入用户名"
                            @keyup.enter.native="focusPassword"
                        >
                            <i slot="prefix" class="iconfont icon-zhanghao"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password" style="position: relative">
                        <el-input
                            ref="pwd"
                            v-model="formData.password"
                            name="password"
                            placeholder="请输入密码"
                            :type="inputType"
                            @keyup.enter.native="doLogin"
                        >
                            <i slot="prefix" class="iconfont icon-mima"></i>
                        </el-input>

                        <span class="password-icon" @click="exchangePwdType">
                            <i
                                v-if="inputType === 'password'"
                                class="iconfont icon-yincangmima"
                                style="font-size: 10px;margin-left: -6px;"
                            ></i>
                            <i v-else class="iconfont icon-xianshimima"></i>
                        </span>
                    </el-form-item>

                    <el-form-item prop="verifycode">
                        <el-input
                            ref="verifycode"
                            v-model="formData.verifycode"
                            name="verifycode"
                            placeholder="请输入验证码"
                            @keyup.enter.native="doLogin"
                            @focus="verifyCodeFocus"
                        >
                            <i slot="prefix" class="iconfont-vcode"></i>
                        </el-input>
                        <div class="verifycode-img">
                            <img :src="verifyImage" alt="" @click="getVerifyCodeInfo" />
                        </div>
                    </el-form-item>
                </el-form>
                <p class="forget-password">
                    <!-- <el-checkbox v-model="checked">记住密码</el-checkbox> -->
                    <router-link to="/retrievePassword">忘记密码?</router-link>
                </p>
                <div class="btn-hover" @click="doLogin">登录</div>

                <p class="login-page-bottom">
                    Copyright © {{ currentYear }}
                    <span class="primarytext">新希望集团 版权所有</span>
                </p>
            </div>
            <div v-show="!showPassWord" class="qrCodeLogin">
                <div class="iconBox" @click="toggleLogin('password')">
                    <el-tooltip placement="top" content="账号登陆">
                        <i class="iconfont icon-Pc"></i>
                    </el-tooltip>
                </div>
                <p class="title">地网无边平台</p>
                <div class="qrcodeCanvas">
                    <div id="qrcode" v-loading="expireLoading"></div>
                    <div v-if="expireSign" class="markQr" @click="getCode">
                        <!-- <i class="iconfont icon-tuzhishuchu-xiazaichajianshuaxin"></i> -->
                        <img class="markQr-img" src="@/assets/pics/sx.png" alt="" />
                    </div>
                </div>
                <p class="bottomText">{{ expireSign ? "二维码已失效，点击刷新" : "请用星海APP扫描二维码登录" }}</p>
                <p class="login-page-bottom">
                    Copyright © {{ currentYear }}
                    <span class="primary">新希望集团 版权所有</span>
                </p>
            </div>
        </div>
        <!-- <login-background></login-background> -->
        <div class="check-cookie-wrapper">
            <el-dialog top="40vh" :show-close="false" width="598px" :visible.sync="dialogCheckCookieVisible">
                <div class="check-cookie-inner">
                    <p>您的浏览器限制了第三方Cookie，这将影响您的正常登录，您可以更改浏览器的隐私设置，解除限制重试</p>
                    <div class="text-right border-T">
                        <a class="link" target="_blank" href="/static/setCookieAllowIntro.html">去设置</a>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import AES from "@/libs/secret";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
import { getVerifyCodeImg } from "@/api";
export default {
    data() {
        return {
            dialogCheckCookieVisible: false,
            qrcode: null,
            qrCodeStr: "",
            getInfoCode: "",
            expireSign: false,
            expireLoading: false,
            timer1: null,
            showPassWord: true,
            api_login: "/auth/authentication/form",
            api_verify: "/auth/oasso/verifycode",
            loading: false,
            loadingVerify: false,
            inputType: "password",
            checked: false,
            formData: {
                username: "",
                password: "",
                verifycode: "",
            },
            verifycodeId: "",
            verifyCodeTime: "",
            verifycodeSrc: "",
            verifyImage: "",
            formRules: {
                username: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
                password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
                verifycode: [
                    { required: true, message: "验证码不能为空", trigger: "blur" },
                    { min: 4, max: 4, message: "输入正确的验证码", trigger: "blur" },
                ],
            },
            currentYear: new Date().getFullYear(),
        };
    },
    computed: {
        ...mapState({
            upadteCheckCookieIsOk: (state) => state.upadteCheckCookieIsOk,
        }),
    },
    watch: {
        upadteCheckCookieIsOk(val) {
            if (!val && this.$mUtils.browser.safari) {
                this.showIntroSetCookie();
            }
        },
    },
    mounted() {
        this.checkErrorInfo();
        this.getVerifyCodeInfo();
        this.visibilityListener();
    },
    beforeDestroy() {
        document.removeEventListener("visibilitychange", () => {});
    },
    methods: {
        // 获取验证码
        async getVerifyCodeInfo() {
            try {
                let id = Number(
                    Math.random()
                        .toString()
                        .substr(3, length) + Date.now()
                ).toString(36);
                this.verifycodeId = id + "";
                this.formData.verifycode = ""; // 清空输入的验证码
                this.verifyImage = `${this.$config.baseURL}/dwwb-portal/verify/actuator/getVerifyCode/${this.verifycodeId}`;
                this.verifyCodeTime = Date.now();
            } catch (err) {
                console.error(err);
            }
        },
        verifyCodeFocus() {
            const limit = 4.5 * 60000; // 4分半钟
            const current = Date.now();
            if (current - this.verifyCodeTime > limit) {
                this.getVerifyCodeInfo();
            }
        },
        visibilityListener() {
            document.addEventListener("visibilitychange", () => {
                if (document.visibilityState === "hidden") {
                    //切离该页面时执行
                    this.$refs.verifycode.blur();
                } else if (document.visibilityState === "visible") {
                    this.verifyCodeFocus();
                }
            });
        },
        /**
         * @description: 检查url地址是否携带错误提示信息，如果有则显示
         * @param {*}
         * @return {*}
         */
        checkErrorInfo() {
            const route = this.$route;
            const query = route.query || {};
            if (query.success === "false" && query.message) {
                // 提示错误信息
                this.$message.error(query.message);
            }
        },
        // 聚焦密码框
        focusPassword() {
            this.$refs.pwd.focus();
        },
        // 检测浏览器兼容模式下自动填充的值，部分浏览器（如360）的兼容模式，自动填充后，不会触发双向绑定更新，因此点击登录时，手动取值并赋值
        checkAutoCompeltedValueOfCompatibleBrowser() {
            const name = document.querySelector("input[name=username]").value;
            const pwd = document.querySelector("input[name=password]").value;
            const form = this.formData;
            if (!form.username && name) {
                form.username = name;
            }
            if (!form.password && pwd) {
                form.password = pwd;
            }
        },
        /**
         * @description: 登陆
         * @param {*}
         * @return {*}
         */
        doLogin() {
            this.checkAutoCompeltedValueOfCompatibleBrowser();
            //调用验证码接口

            this.$refs.loginForm.validate(async (valid) => {
                let verifycodeId = this.verifycodeId;
                let verifycodeDate = this.formData.verifycode;

                if (valid) {
                    let formData = { ...this.formData };
                    formData.password = AES.Encrypt(formData.password);
                    try {
                        const { code, message } = await getVerifyCodeImg({
                            verifycodeId,
                            verifycodeDate,
                        });
                        if (code !== "0000") {
                            this.$message.error(message);
                            return;
                        }
                        this.submitLogin(formData);
                    } catch (err) {
                        this.$message.error("验证码错误！");
                    }
                } else {
                    // this.$message.error("请正确填写表单！");
                    return false;
                }
            });
        },
        // 提交登录数据
        submitLogin(formData) {
            const route = this.$route;
            const query = route.query || {};
            //登录成功后的回跳地址
            const redirect_uri = (query.redirect_uri && decodeURIComponent(query.redirect_uri)) || location.origin;
            const data = {
                client_id: "portal",
                response_type: "code",
                redirect_uri,
                login_page: location.origin + "/#/login",
                ...formData,
            };
            this.submitForm(data);
        },
        /**
         * @description: 一个假的密码登录框
         * @param {*} data
         * @return {*}
         */
        submitForm(data) {
            const $form = document.createElement("form");

            $form.setAttribute("action", this.$config.ucFormLoginUrl + "/auth/authentication/form");
            $form.setAttribute("method", "post");
            for (let key in data) {
                const $el = document.createElement("input");
                $el.setAttribute("name", key);
                $el.value = data[key];
                $form.appendChild($el);
            }
            document.documentElement.appendChild($form);
            $form.submit();
        },
        exchangePwdType() {
            if (this.inputType === "text") {
                this.inputType = "password";
            } else {
                this.inputType = "text";
            }
        },
        showIntroSetCookie() {
            this.dialogCheckCookieVisible = true;
        },
        //code登录准备
        beforeCodeSubmit() {
            const route = this.$route;
            const query = route.query || {};
            //登录成功后的回跳地址
            const redirect_uri = (query.redirect_uri && decodeURIComponent(query.redirect_uri)) || location.origin;
            const data = {
                grant_type: "qrcode",
                code: this.getInfoCode,
                client_id: "portal",
                response_type: "code",
                redirect_uri,
                login_page: location.origin + "/#/login",
            };
            this.codeSubmit(data);
        },
        //code模拟form登录框
        codeSubmit(data) {
            const $form = document.createElement("form");
            $form.setAttribute("action", this.$config.baseURL + "/auth/oauth/appqr/code");
            $form.setAttribute("method", "post");
            for (let key in data) {
                const $el = document.createElement("input");
                $el.setAttribute("name", key);
                $el.value = data[key];
                $form.appendChild($el);
            }
            document.documentElement.appendChild($form);
            $form.submit();
        },
        // 扫码登录，轮询登录结果
        checkLogin() {
            let that = this;
            this.timer1 = setInterval(() => {
                if (that.getInfoCode) {
                    that.$axios
                        .get("/auth/qrcode/check?code=" + that.getInfoCode)
                        .then((res) => {
                            if (parseInt(res.body.countDown) === 1) {
                                that.$message({
                                    type: "warning",
                                    message: "二维码失效，请重新扫描！",
                                });
                                that.expireSign = true;
                                that.expireLoading = false;
                                window.clearInterval(that.timer1);
                            } else {
                                if (String(res.body.status) === "1") {
                                    that.expireLoading = true;
                                }
                                if (String(res.body.status) === "2") {
                                    window.clearInterval(that.timer1);
                                    this.beforeCodeSubmit();
                                }
                            }
                        })
                        .catch(() => {
                            that.expireLoading = false;
                            that.expireSign = true;
                            that.$message({ type: "error", message: "登录失败！" });
                            window.clearInterval(that.timer1);
                        });
                }
            }, 3000);
        },
        getCode() {
            this.expireLoading = true;
            this.expireSign = false;
            this.$axios
                .get("/auth/qrcode/getCode")
                .then((res) => {
                    this.qrCodeStr = res.qrCode;
                    this.getInfoCode = res.code;
                    this.createQrcode(res.qrCode);
                    this.checkLogin();
                })
                .catch(() => {
                    this.expireLoading = false;
                    this.expireSign = true;
                    this.$message({ type: "error", message: "获取二维码失败！" });
                });
        },
        toggleLogin(sign) {
            if (sign === "password") {
                this.showPassWord = true;
                window.clearInterval(this.timer1);
            } else {
                this.showPassWord = false;
                window.clearInterval(this.timer1);
                this.getCode();
            }
        },
        createQrcode(str) {
            if (this.qrcode) {
                this.qrcode.clear(); // clear the code.
                this.qrcode.makeCode(str);
            } else {
                this.qrcode = new QRCode("qrcode", {
                    width: 152,
                    height: 152,
                    text: str, // 二维码地址
                });
            }
            this.expireLoading = false;
            this.expireSign = false;
        },
        // 获取个人权限
        getUserPerMision() {
            this.$store.dispatch("getUserPermission", {
                callback: () => {
                    this.redirectFn();
                },
            });
        },
        // 登陆完跳转
        redirectFn() {
            this.$router.replace("/");
        },
        //获取个人信息
        getUserInfo() {
            this.$store.dispatch("getUserInfo");
        },
    },
};
</script>
<style lang="scss" scoped>
.iconfont-vcode {
    display: inline-block;
    background: url(../common/images/yzm.png) no-repeat;
    height: 14px;
    width: 14px;
    background-size: 100% 100%;
    margin-left: 3px;
    margin-top: 3px;
}
.verifycode-img {
    position: absolute;
    right: 5%;
    top: 7px;
    height: 30px;
    width: 80px;
    img {
        width: 100%;
        height: 100%;
    }
}
.password-icon {
    cursor: pointer;
    position: absolute;
    right: 0px;
    top: 0;
    color: #999;
    display: inline-block;
    width: 30px;
    text-align: center;
}

.page-login {
    height: 100%;
    width: 100%;
    padding: 1px;
    background-repeat: no-repeat;
    background: rgba(255, 255, 255, 0.68);
    background-image: url("../assets/pics/dwwbimg.png");
    background-position-x: center;
    background-position-y: center;
    background-size: 100% 100%;
    position: relative;
}
.login-page-inner {
    position: absolute;
    z-index: 99;
    top: 50%;
    left: 61%;
    margin-right: -100px;
    margin: -180px auto 0;
    /*  padding: 20px 40px;*/
    width: 408px;
    height: 455px;
    background: rgba(255, 255, 255, 0.68);
    border-radius: 12px;
    // border: 1px solid rgba(255, 255, 255, 0.51);

    .iconBox {
        width: 100px;
        height: 100px;
        -webkit-transform: rotateZ(45deg);
        transform: rotateZ(45deg);
        position: absolute;
        right: -50px;
        top: -50px;
        color: #ffffff;
        background: linear-gradient(-30deg, rgba(218, 218, 218, 1), rgba(255, 255, 255, 1));
        overflow: hidden;
        cursor: pointer;
        img {
            position: absolute;
            left: 33px;
            bottom: -9px;
            transform: rotateZ(-45deg);
            width: 33px;
            height: 33px;
        }

        i {
            font-size: 30px;
            position: absolute;
            left: 33px;
            bottom: -9px;
            transform: rotateZ(-45deg);
            color: $primary;
        }
    }

    .passHidden {
        transition: rotateY(-180deg);
        backface-visibility: visible;
        transition: rotate() visiblity 1s;
    }

    .passwordLogin {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 2;
        width: 100%;
        height: 100%;
        padding: 30px 40px 18px;
        overflow: hidden;

        background: rgba(255, 255, 255, 0.68);
        border-radius: 12px;
    }
    .qrCodeLogin {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        width: 100%;
        height: 100%;
        padding: 40px;
        padding-bottom: 18px;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.68);
        text-align: center;

        .qrcodeCanvas {
            display: inline-block;
            position: relative;
            min-height: 152px;

            .markQr {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0px;
                left: 0px;
                z-index: 20;
                background: rgba(255, 255, 255, 0.9);
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;
                cursor: pointer;
                .markQr-img {
                    width: 48px;
                    height: 48px;
                }

                // i {
                //     font-size: 40px;
                // }
                img {
                    font-size: 40px;
                }
            }
        }

        .bottomText {
            color: #000;
            text-align: center;
            margin-top: 13px;
            margin-bottom: 45px;
        }
    }

    .title {
        margin-bottom: 34px;
        text-align: center;
        width: 328px;
        padding-top: 30px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
    }

    /**
    鼠标悬浮渐变
    */
    .btn-hover {
        margin-top: 31px;
        text-align: center;
        color: white;
        // background: $color-gradient;
        transition: all 3s;
        border-radius: 4px;
        line-height: 44px;
        cursor: pointer;
        margin-bottom: 20px;
        width: 328px;
        height: 44px;
        background: #3a9d80;
        border-radius: 22px;
    }

    .btn-hover:hover {
        transition: all 3s;
        background: linear-gradient(to right, #5ac66a 0%, #3aa27f 60%, #207b5d 100%);
    }

    .btn-hover:active {
        transition: all 3s;
        background: linear-gradient(to right, #5ac66a 0%, #3aa27f 40%, #207b5d 100%);
    }

    .login-page-bottom {
        font-size: 12px;
        color: #666;
        text-align: center;
        .primarytext {
            color: #3a9d80;
            font-weight: 500;
        }
    }
}

.forget-pwd {
    display: flex;
    justify-content: flex-end;
}
.forget-password {
    // text-align: right;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    // margin-bottom: ;

    > a {
        // font-size: 15px;
        // margin-bottom: 20px;
        // cursor: pointer;
        // color: $primary;
        // margin-top: -10px;

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3a9d80;
    }
    /deep/.el-checkbox__label {
        font-size: 16px !important;
    }
}

.login-logo {
    z-index: 99;
    width: 473px;
    height: 32px;
    position: absolute;
    top: 32px;
    left: 52px;
    color: white;

    // .iconfont {
    //     font-size: 26px;
    // }
}

.verify-code-img {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(146, 206, 174, 0.26);

    img {
        display: inline-block;
        max-width: 100%;
        max-height: 100%;
    }
}

/**
  用于css媒体查询设置
  */

@media screen and (max-width: 1900px) {
    .page-login {
        /*background-image: url(../common/images/login_bg.jpg);*/
    }
}

@media screen and (max-width: 1600px) {
    .page-login {
        /*background-image: url(../common/images/login_bg_1366.jpg);*/
    }
}
</style>
<style lang="scss">
.check-cookie-wrapper {
    .check-cookie-inner {
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        a {
        }
        & > p {
            padding: 30px 20px 20px;
            line-height: 1.8;
        }
        & > div {
            padding: 16px 20px 16px;
        }
    }
    .el-dialog {
        background: transparent;
    }
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        background: transparent;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        padding: 0;
    }
    .el-form-item__content,
    .el-input__inner {
        max-height: 40px !important; //解决360兼容模式兼容性问题
    }
}
.page-login {
    .el-input__inner::placeholder {
        color: #999;
    }
    .icon-zhanghao,
    .icon-mima {
        color: #898989;
    }
}
</style>
